import React, { useEffect, useState } from "react";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { UserFormServiceButtonClose, UserFormServiceButtonCreated } from "../../MyBooking/styled/DesStyled";
import useBanUserAdmin from "../hook/BanUserAdmin";

export default function DialogBanUser(props: {
	openDialog: boolean;
	setOpenDialog: (v: boolean) => void;
	userId: string | null;
	reload: () => void;
}) {
	const [reason, setReason] = useState("");
	const { banUserAd, MIN_BAN_REASON } = useBanUserAdmin({ reload: props.reload });

	useEffect(() => {
		if (props.openDialog) setReason("");
	}, [props.openDialog]);

	const handleConfirm = async () => {
		if (!props.userId) return;
		await banUserAd(props.userId, reason);
		props.setOpenDialog(false);
	};

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => props.setOpenDialog(false)}
			title="Ban user"
			actions={
				<>
					<UserFormServiceButtonClose type="button" onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated type="button" onClick={() => void handleConfirm()}>
						Confirm ban
					</UserFormServiceButtonCreated>
				</>
			}
		>
			<p style={{ marginBottom: 8, fontSize: 13 }}>
				Minimum <strong>{MIN_BAN_REASON}</strong> characters. This blocks login and all API access for this
				customer account.
			</p>
			<textarea
				style={{
					width: "100%",
					minHeight: 100,
					padding: 8,
					fontSize: 13,
					boxSizing: "border-box",
				}}
				placeholder="Reason for ban…"
				value={reason}
				onChange={(e) => setReason(e.target.value)}
			/>
		</DialogWrapMedium>
	);
}
